export const UserProfileModel = {
    id: "",
    userId: "",
    firstName: "",
    lastName: "",
    email: "",
    userName: "",
    prefferedName: "",
    phone: null,
    birthday: null,
    gender: null,
    country: null,
    countryId: null,
    streetAddress: null,
    city: null,
    state: null,
    postalCode: null,
    description: null,
    profilePicture: null,
    video: "",
    profilePictureUrl:null
  };
  